import React from 'react'
import { Alert } from 'antd'
import { AlertModule as AlertModuleConfig, CardModule } from '@/component/common/report/reportConfigModel'
import styled from 'styled-components'
import { ReportConfig, ReportParams } from '@/component/common/report/report'
import { UseGetDataResultReturnType } from '@/component/PageComponent/hooks/requst'
import { useCustomCardHooks } from '@/component/ReportCommon/CustomCard/CustomCard'
import { serviceQuickBiReportDataV2 } from '@/component/Report/services/bi/bi'
import { isErrorPc } from '@/component/PageComponent/errorPc'

type Props = {
  reportConfig: ReportConfig
  moduleItem: AlertModuleConfig
  dataHandler: UseGetDataResultReturnType<ReportParams>
  wrapperStyle?: React.CSSProperties
}

export const AlertModule: React.FC<Props> = ({ reportConfig, moduleItem, dataHandler, wrapperStyle }) => {
  const { message, description, alertType, showIcon, closable, backgroundColor, padding, margin, borderRadius, dataIndex, source } = moduleItem

  const enabled = !!dataIndex

  const cardModule = React.useMemo<CardModule>(
    () => ({
      type: 'card',
      source: source || '',
      list: [
        {
          name: message,
          valueField: dataIndex || '',
          relativeRatioField: '__alert_relative_ratio__',
        },
      ],
    }),
    [dataIndex, message, source],
  )

  const { cardInfo } = useCustomCardHooks({
    reportConfig,
    moduleItem: cardModule,
    dataHandler,
    getBiReportCardData: serviceQuickBiReportDataV2,
    isError: isErrorPc,
    enabled,
  })

  const dataIndexValue = enabled ? cardInfo?.[dataIndex] : undefined
  const messageText = enabled ? (dataIndexValue ?? message) : message

  if(!messageText){
    return null
  }

  return (
    <AlertView
      style={wrapperStyle}
      $backgroundColor={backgroundColor}
      $padding={padding}
      $margin={margin}
      $borderRadius={borderRadius}
    >
      <Alert
        message={messageText}
        description={description}
        type={alertType || 'warning'}
        showIcon={showIcon ?? true}
        closable={!!closable}
      />
    </AlertView>
  )
}

const AlertView = styled.div<{
  $backgroundColor?: string
  $padding?: string
  $margin?: string
  $borderRadius?: number | string
}>`
  background-color: ${p => p.$backgroundColor ?? 'transparent'};
  padding: ${p => p.$padding ?? '20px 16px 0 16px'};
  margin: ${p => p.$margin ?? '0'};
  border-radius: ${p => (p.$borderRadius === undefined ? '0' : typeof p.$borderRadius === 'number' ? `${p.$borderRadius}px` : p.$borderRadius)};
`

export default AlertModule
